import React, { useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const CustomerBlockUnblock = (props) => {
  const [zPos, setZPos] = useState(45)
  const [reason, setReason] = useState(-1);
  const [comment, setComment] = useState("");
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const onSelectReason = (event: React.ChangeEvent<{ value: unknown }>) => {
    let value = event.target.value as string;
    setReason(Number(value));
    validate(value, comment)
  };
  const changeValue = (e) => {
    setComment(e.target.value);
    validate(reason, e.target.value)
  };
  const validate = (r, c) => {
    if (Number(r) > -1 && c) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }   
  }

  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = {
      customer: {uuid: props.data.uuid},
      action: !props.blocked ? "block" : "unblock",
      reason: reason,
      comment: comment
    };

    let request = await API.service( "customerBlockUnblock", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200 && request.data.data.response === "OK") {
      let d = props.data;
      d.status = "blocked";
      await props.reloadData(d.uuid);
      props.changeStatus(d);
      props.setBlocked(true);
      props.changeAlert(true, "success", "Usuario bloqueado con éxito");
      closelightbox();
    }
    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Bloquear usuario: <p id="subtitle">{props.data.name}</p>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} sx={{paddingTop: "5px"}}>
            <Grid item xs={6}>
              <TextField label="Motivo" value={reason} onChange={onSelectReason.bind(this)} select	size="small" fullWidth >
                <MenuItem value="-1" disabled>Selecione</MenuItem>
                {props.catalogs.map((item, index) => (
                  <MenuItem key={`block-option-${index}`} value={item["k"]}>{item["v"]}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
							<TextField label="Comentarios" value={comment} onChange={changeValue.bind(this)} size="small" fullWidth />
						</Grid>
          </Grid>
        </DialogContent>

        <DialogActions>					
          <Button disabled={disabled} variant="contained" onClick={send} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default CustomerBlockUnblock;